import React from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import DOMPurify from 'dompurify'

interface PanoramaProps {
  panoramas?: any
  assetUrl?: string
}
const Panoramas = ({ panoramas, assetUrl }: PanoramaProps) => {
  const { locId } = useSelector((state: any) => state.location)

  return (
    <>
      {panoramas?.map((panorama: any) => (
        <div
          tabIndex={0}
          aria-label={`${panorama.title + '.'} ${
            panorama.accessibility_description || panorama.description || ''
          }`}
        >
          <h3>{panorama.title}</h3>
          <Box
            component={'div'}
            sx={{
              width: '100%',
              maxHeight: '450px',
              background: '#f2f3f4',
              textAlign: 'center',
            }}
          >
            <Box
              sx={{ maxHeight: '450px', width: '100%' }}
              component={'img'}
              src={`${assetUrl}/media/${locId}/panoramas/${panorama.id || panorama.hotspotMediaId || panorama.media_id}/1024.jpg`}
              alt={panorama.accessibility_description}
            />
          </Box>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(panorama.description, { ADD_ATTR: ['target'] }),
            }}
          />
        </div>
      ))}
    </>
  )
}

export default Panoramas
